export default "__VITE_PUBLIC_ASSET__773a3948__"